// extracted by mini-css-extract-plugin
module.exports = {"stickyContainer":"sticky-header-module--stickyContainer--2WSs_","donateButton":"sticky-header-module--donateButton--2Oo8V"};